import React from "react";

import { useTranslation } from "react-i18next";

import { Button } from "@components/buttons";
import { WalletIcon } from "@components/icons/WalletIcon";
import WalletTag from "@components/shared/WalletTag";
import { AccStatementBetSlipEventInOffer } from "@data-types/account-statement/AccountStatementBetSlip";
import { useAccountStatementStore } from "@state/hooks/account-statement/useAccountStatementStore";
import { prepareOfferData } from "@utils/account-statement/AccountStatementUtils";
import { shouldShowBetSlipStatus as ShouldShowBetSlipStatus } from "@utils/offer/shouldShowBetSlipStatus";
import { shouldUseSlipStatusInstead } from "@utils/offer/shouldUseSlipStatusInstead";
import FreebetTag from "@components/shared/FreebetTag";

export function Header(props: {
	slipDetails: AccStatementBetSlipEventInOffer;
}) {
	const store = useAccountStatementStore();

	const {
		isLive,
		betSlipNumber,
		betSlipStatus,
		bettingAccountType,
		isBonus,
        transactionTypeAbrv
	} = props.slipDetails;

	const { t } = useTranslation();

	const shouldShowBetSlipStatus = ShouldShowBetSlipStatus(props.slipDetails);

	const finalOffers = prepareOfferData(props.slipDetails);

	const hasBetBuilder = finalOffers.some(
		(betOffer) => betOffer.multiOffers && betOffer.multiOffers.length
	);

	let betStatus = props.slipDetails.betStatus;
	let betStatusClass = `tag tag--base tag--bet tag--bet--${betStatus.abrv}`;

	if (shouldUseSlipStatusInstead(props.slipDetails)) {
		betStatus = props.slipDetails.betSlipStatus;
		betStatusClass =
			"card--bet__status tag tag--base tag--slip tag--slip--" +
			betSlipStatus.abrv;
	}

	return (
		<div className="popup__header">
			<div className="popup__title u-type--base u-gap--xsml">
				<div className={betStatusClass}>
					{t<string>(
						isLive
							? "ACC_STATEMENT.BET_DETAILS.BET_SLIP_NUMBER_LIVE"
							: "ACC_STATEMENT.BET_DETAILS.BET_SLIP_NUMBER",
						{
							0: betSlipNumber,
							1: t<string>(betStatus.name).toUpperCase(),
						}
					)}{" "}
					{isBonus && <> ({t<string>("COMMON.BONUS")})</>}
				</div>

				{shouldShowBetSlipStatus && (
					<div
						className={
							"card--bet__status tag tag--base tag--slip tag--slip--" +
							betSlipStatus.abrv
							// + "--inverted"
						}
					>
						{betSlipStatus.name}
					</div>
				)}

				{hasBetBuilder && (
					<span
						className={
							"card--bet__status tag--bb tag--bb--grow tag tag--base tag--bet"
						}
					>
						Bet Builder
					</span>
				)}

                <FreebetTag
                    isFreebet={props.slipDetails.isFreebet}
                    transactionTypeAbrv={transactionTypeAbrv}
                    className="tag--base"
                />

				<WalletTag
					isWalletManuallyDisabled={
						props.slipDetails.isWalletManuallyDisabled || false
					}
				/>

				<WalletIcon
					bettingAccountTypeAbrv={
						bettingAccountType != null
							? bettingAccountType.abrv
							: ""
					}
					isWalletManuallyDisabled={
						props.slipDetails.isWalletManuallyDisabled || false
					}
				/>
			</div>

			<Button
				type="button"
				onClick={() =>
					store.accountStatementDetailsStore.setDetailsType(0)
				}
				className="popup__close btn--square btn--square--xsml btn--primary--inverted"
				iconClassName="u-icon--tny u-icon--close"
				iconOnly={true}
				title={t("COMMON.CLOSE")}
			/>
		</div>
	);
}
